import { requestGet } from '@/common/request';

interface reqParams {
  groupId: number; //	分组ID 	是
}

interface ResultData {
  data: number; //	未读数量
}

/**
 * 消息中心-查询单个分组未读消息数量
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1121439607
 */
export default function genericMessageGroupMessageNum(query: reqParams): Promise<RequestResult<ResultData>> {
  return requestGet('/generic/platMktMsgBk/message/groupMessageNum', query);
}
